
export const pageData = [
    {
        id: 1,
        title: 'Free cancellation',
        description: 'Cancel up to 24 hours in advance for a full refund',
    },
    {
        id: 2,
        title: 'Reserve now & pay later',
        description: 'Keep your travel plans flexible - book your spot and pay nothing today.',
    },
    {
        id: 3,
        title: 'Duration 4 - 6 hours',
        description: 'Check availability to see starting times.',
    },
    {
        id: 4,
        title: 'Pickup included',
        description: 'Pickup available within 10 kilometres of the city of Chiang Mai. Please wait at the lobby of your hotel. The pickup time is around 8:30 AM - 9:00 AM.',
    },
    {
        id: 5,
        title: 'Instructor',
        description: 'English/Hindi',
    },
    {
        id: 6,
        title: 'Small group',
        description: 'Limited to 10 participants',
    },
]